import { ArrowLeft, Code2, Globe2, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import ConnectExistingWebsite from "@/components/ConnectExistingWebsite";
import NoIndex from "@/components/NoIndex";

export default function WebsiteIntegrations() {
  return (
    <div className="max-w-4xl space-y-6" data-testid="website-integrations-page">
      <NoIndex />
      <div>
        <Link to="/app/settings" className="inline-flex items-center gap-1 text-sm text-slate-600 hover:text-emerald-700">
          <ArrowLeft className="w-4 h-4" /> Settings
        </Link>
        <h1 className="font-display text-3xl sm:text-4xl font-bold mt-3">Website &amp; Integrations</h1>
        <p className="text-slate-600 mt-1 max-w-2xl">
          Keep your existing website and prepare ConfirmPH to provide the booking experience behind it.
        </p>
      </div>

      <div className="grid sm:grid-cols-3 gap-3">
        <Summary icon={Globe2} title="Your website" text="Connection and public link" />
        <Summary icon={ShieldCheck} title="Ownership" text="Verified-domain controls" />
        <Summary icon={Code2} title="Booking integration" text="Hosted page and embed shell" />
      </div>

      <ConnectExistingWebsite expanded />
    </div>
  );
}

function Summary({ icon: Icon, title, text }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4">
      <Icon className="w-5 h-5 text-emerald-700" />
      <div className="font-semibold text-sm mt-2">{title}</div>
      <div className="text-xs text-slate-500 mt-0.5">{text}</div>
    </div>
  );
}
